module.exports = __webpack_public_path__ + "img/book-h.0ea8290b.png";